
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styles from './Button.css';
import Loading from '../Loading';

class Button extends React.Component {
    componentDidUpdate(prevProps) {
        if (this.props.focus && prevProps.focus !== this.props.focus) {
            setTimeout(() => {
                if (this.ref) {
                    this.ref.focus();
                }
            });
        }
    }
    render() {
        const {
            children,
            className,
            loading,
            primaryColor,
            dispatch, // eslint-disable-line
            focus, // eslint-disable-line
            disabled,
            style,
            gray,
            type,
            ...props
        } = this.props;
        const isLink = (props.to || props.href) && !disabled && !gray;
        let ButtonEl = 'button';
        const elementType = isLink ? undefined : type;
        let ref = 'ref';
        if (isLink && props.href) {
            ButtonEl = 'a';
        } else if (isLink && props.to) {
            ButtonEl = Link;
            ref = 'innerRef';
        }
        props[ref] = (r) => {
            this.ref = r;
        };
        if (loading) {
            props['aria-busy'] = 'true';
            props['aria-live'] = 'polite';
        }
        return (<ButtonEl
            className={cx(styles.button, className)}
            disabled={disabled || loading}
            style={{
                backgroundColor: (disabled || loading || gray) ? '#767676' : primaryColor,
                cursor: disabled ? 'default' : 'pointer',
                ...style,
            }}
            type={elementType}
            {...props}
            {...(disabled || loading ? { 'aria-disabled': 'true' } : {})}
            aria-label={loading ? 'Loading' : props['aria-label']}
        >
            {loading ? <Loading color="white" size={20} /> : children}
        </ButtonEl>);
    }
}

Button.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    primaryColor: PropTypes.string,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    gray: PropTypes.bool,
    style: PropTypes.object,
    type: PropTypes.string,
    to: PropTypes.string,
    focus: PropTypes.bool,
};

Button.defaultProps = {
    style: {},
    type: 'button',
};

export default connect(({ theme }) => ({
    primaryColor: theme.primaryColor,
}))(Button);



// WEBPACK FOOTER //
// ./src/client/Components/Button/Button.js